export default __webpack_public_path__ + "static/media/offer-vertical-chocolate.d1bdc44e.png";